import styled from "@mui/material/styles/styled";
import { TimePicker } from "@mui/x-date-pickers";
const TimePickerStyled = styled(TimePicker)`
  width: 100%;
  .MuiInputBase-root {
    background-color: var(--mui-palette-elevation0-transparent);
    padding: 10px;
    border-radius: 8px;
  }
  .MuiInputBase-input {
    padding:0;
    box-sizing: border-box;
    height: 23px;
    font-size: 16px;
  }
  .MuiOutlinedInput-notchedOutline {
    border: 0;
  }

  .MuiInputAdornment-root .MuiIconButton-root:hover{
    background-color: initial;
  };
`;
export {
  TimePickerStyled
};
